
const atualizarDrawer = (state, drawer) => {
    state.drawer = drawer;
}

export default {
    atualizarDrawer
}